import React, { useEffect, useState } from "react";
import { useAuth } from "@/contexts/AuthContext";
import { refreshLeadOptions } from "@/lib/api";
import { canAccess, sectionForPath } from "@/lib/sections";
import { Outlet, useLocation } from "react-router-dom";
import Sidebar from "@/components/layout/Sidebar";
import Topbar from "@/components/layout/Topbar";
import AdminEODSummary from "@/components/AdminEODSummary";
import { LiveLeadAlerts } from "@/components/LiveLeadAlerts";
import { ImpersonationBanner } from "@/components/PasswordTools";

export default function AppLayout() {
  const [navOpen, setNavOpen] = useState(false);
  const { user } = useAuth();
  const [optsFor, setOptsFor] = useState(null);
  const org = user?.active_organization_id || "none";
  const { pathname } = useLocation();
  useEffect(() => { refreshLeadOptions().then(() => setOptsFor(org)); }, [org]);
  return (
    <div className="flex min-h-screen bg-bone">
      <Sidebar open={navOpen} onClose={() => setNavOpen(false)} />
      <div className="flex-1 min-w-0 flex flex-col">
        <ImpersonationBanner />
        <Topbar onMenu={() => setNavOpen(true)} />
        <main className="flex-1 min-w-0 p-4 sm:p-8 animate-fade-in">
          {optsFor !== org ? <div data-testid="app-loading" className="text-sm text-forest/50">Loading…</div>
            : canAccess(user, sectionForPath(pathname)) ? <Outlet /> : (
              <div data-testid="no-access" className="max-w-md border border-[#E6E4DD] bg-white rounded-sm p-8">
                <div className="label-caps">No access</div>
                <h2 className="font-display font-bold text-2xl text-forest mt-2">This section is turned off for you</h2>
                <p className="text-sm text-forest/60 mt-2">Ask your admin to switch it on from Team → Permissions.</p>
              </div>
            )}
        </main>
      </div>
      <AdminEODSummary mode="modal-controller" />
      <LiveLeadAlerts />
    </div>
  );
}
